import QdContainer from 'components/Common/QdContainer'
import React, { useState } from 'react'
import Header from './Header'
import ConfigDetail from './ConfigDetail'
import RuleEditor from './RuleEditor'
import LocationMappingRules from './LocationMappingRules'
import LocationMappingRuleEditor from './LocationMappingRuleEditor'
import LocationMappingRulesMoved from './LocationMappingRulesMoved'
import { Provider } from './ConfigContext'
import ConfigCardsList from './ConfigCardsList'
import FollowupMgmtDelete from './FollowupMgmtDelete'
import ReopenManualReview from './ReopenManualReview'
import LlmInstructionsPanel from 'pages/CRSManagement/LlmInstructions/Panel'

// Location mapping rules were ported to the admin portal as pre-processing
// rules, so the card now opens a notice instead of the rules table. The old
// list and editor are deliberately left in place - flip this to true to get
// them back.
const SHOW_LEGACY_LOCATION_MAPPING = false

function ConfigManagement() {
    const [currentView, setCurrentView] = useState('cards')
    const [selectedConfig, setSelectedConfig] = useState(null)
    const [selectedRule, setSelectedRule] = useState(null)

    const handleConfigSelect = (configType) => {
        setSelectedConfig(configType)
        if (configType.type === 'LOC_MAPPING_RULES') {
            setCurrentView('location-mapping')
        } else if (configType.type === 'FOLLOWUP_MGMT_DELETE') {
            setCurrentView('followup-delete')
        } else if (configType.type === 'REOPEN_MANUAL_REVIEW') {
            setCurrentView('reopen-manual-review')
        } else if (configType.type === 'LLM_INSTR_TUNING') {
            setCurrentView('llm-instr-tuning')
        } else {
            setCurrentView('detail')
        }
    }

    const handleRuleEdit = (rule) => {
        setSelectedRule(rule)
        if (selectedConfig && selectedConfig.type === 'LOC_MAPPING_RULES') {
            setCurrentView('location-mapping-editor')
        } else {
            setCurrentView('editor')
        }
    }

    const handleBackToCards = () => {
        setCurrentView('cards')
        setSelectedConfig(null)
        setSelectedRule(null)
    }

    const handleBackToDetail = () => {
        if (selectedConfig && selectedConfig.type === 'LOC_MAPPING_RULES') {
            setCurrentView('location-mapping')
        } else {
            setCurrentView('detail')
        }
        setSelectedRule(null)
    }

    const handleRuleSave = () => {
        if (selectedConfig && selectedConfig.type === 'LOC_MAPPING_RULES') {
            setCurrentView('location-mapping')
        } else {
            setCurrentView('detail')
        }
        setSelectedRule(null)
    }

    return (
        <Provider>
            <QdContainer>
                <Header 
                    currentView={currentView}
                    selectedConfig={selectedConfig}
                    onBackToCards={handleBackToCards}
                    onBackToDetail={handleBackToDetail}
                />
                
                {currentView === 'cards' && (
                    <ConfigCardsList onConfigSelect={handleConfigSelect} />
                )}
                
                {currentView === 'detail' && (
                    <ConfigDetail
                        configType={selectedConfig}
                        onRuleEdit={handleRuleEdit}
                    />
                )}

                {currentView === 'location-mapping' && (
                    SHOW_LEGACY_LOCATION_MAPPING ? (
                        <LocationMappingRules
                            configType={selectedConfig}
                            onRuleEdit={handleRuleEdit}
                        />
                    ) : (
                        <LocationMappingRulesMoved />
                    )
                )}

                {currentView === 'editor' && (
                    <RuleEditor
                        rule={selectedRule}
                        configType={selectedConfig}
                        onSave={handleRuleSave}
                        onCancel={handleBackToDetail}
                    />
                )}

                {/* Only reachable from the legacy list above, so it is gated on the
                    same flag rather than left as a dead-but-renderable view. */}
                {SHOW_LEGACY_LOCATION_MAPPING && currentView === 'location-mapping-editor' && (
                    <LocationMappingRuleEditor
                        rule={selectedRule}
                        configType={selectedConfig}
                        onSave={handleRuleSave}
                        onCancel={handleBackToDetail}
                    />
                )}

                {currentView === 'followup-delete' && (
                    <FollowupMgmtDelete />
                )}

                {currentView === 'reopen-manual-review' && (
                    <ReopenManualReview />
                )}

                {currentView === 'llm-instr-tuning' && (
                    <LlmInstructionsPanel />
                )}
            </QdContainer>
        </Provider>
    )
}

export default ConfigManagement
